import axios from 'axios';
import ConfigConnection from '../config/config.service';
export default class RoleService{
  //API Instance
  configConnection: any = new ConfigConnection();

  get(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {

        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}role?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  create(role){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.post(`${_.configConnection.apiInstance}role`, role, config);
  }

  edit(role, idRole){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.put(`${_.configConnection.apiInstance}role/${idRole}`, role, config);
  }

  getById(idRole){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}role/${idRole}`, config);
  }
  delete_role(idRole){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.delete(`${_.configConnection.apiInstance}role/${idRole}`, config);
  }

  getInactive(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}role/inactive?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  active_role(idRole, reactivate){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}role/${idRole}/reactivate`, config);
  }
}
